import { render, staticRenderFns } from "./PurcsaleDetail.vue?vue&type=template&id=6cb42afc"
import script from "./PurcsaleDetail.vue?vue&type=script&lang=js"
export * from "./PurcsaleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports